import { Reveal } from "./Reveal";
import { Waves, Flower2, Home as HomeIcon, MapPin } from "lucide-react";

const MAIN_IMG = "https://customer-assets-lxgj4vgw.emergentagent.net/job_retreat-interactive/artifacts/0rz2m8sw_pool.webp";
const ACCENT_IMG =
  "https://images.unsplash.com/photo-1596625820723-f0f481ff80be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxkZXNlcnQlMjBsYW5kc2NhcGUlMjBqb3NodWElMjB0cmVlJTIwc3Vuc2V0fGVufDB8fHx8MTc4MjE4MDMwOXww&ixlib=rb-4.1.0&q=85";

const amenities = [
  {
    icon: Waves,
    title: "Mineral Spring Pools",
    desc: "Soak in naturally heated, mineral-rich spring pools beneath the open desert sky — drawn from the earth to soften the body and quiet the mind.",
  },
  {
    icon: Flower2,
    title: "Yoga & Meditation Area",
    desc: "A serene, sun-washed sanctuary for guided yoga, breathwork and sound baths, framed by the timeless silence of the high desert.",
  },
  {
    icon: HomeIcon,
    title: "Indoor Amenities",
    desc: "Thoughtfully appointed interiors with plush lounges, a curated kitchen and restful private quarters — luxury that feels like coming home.",
  },
];

export const Location = () => (
  <section id="location" className="py-24 md:py-32">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 relative">
          <Reveal>
            <div className="overflow-hidden rounded-[2rem] aspect-[5/4]">
              <img
                src={MAIN_IMG}
                alt="Mineral spring pool overlooking the desert at sunset"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="absolute -bottom-8 -right-4 sm:-right-8 w-40 sm:w-56 overflow-hidden rounded-2xl aspect-square border-4 border-sand hidden sm:block">
              <img src={ACCENT_IMG} alt="Joshua Tree at golden hour" className="w-full h-full object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal>
            <p className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-clay mb-6">
              <MapPin size={14} /> The location
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-ink leading-[1.05]">
              Joshua Tree Hot Springs House
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-3 text-muted">29 Palms, California</p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base sm:text-lg text-muted leading-relaxed max-w-xl">
              Tucked into the luminous stillness of the high desert, our private retreat house is an
              oasis of warm minerals, wide skies and golden light. Days unfold slowly here — between
              steaming spring pools, candlelit yoga and the kind of silence you can finally hear.
            </p>
          </Reveal>

          <div className="mt-10 space-y-6">
            {amenities.map((a, i) => (
              <Reveal key={a.title} delay={0.25 + i * 0.1}>
                <div data-testid={`amenity-${i}`} className="flex items-start gap-5">
                  <div className="shrink-0 w-12 h-12 rounded-full bg-surface flex items-center justify-center text-forest">
                    <a.icon size={20} />
                  </div>
                  <div>
                    <h3 className="font-serif text-2xl text-ink leading-none">{a.title}</h3>
                    <p className="mt-2 text-muted leading-relaxed max-w-lg">{a.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
